import { toast } from "sonner";
import ResourcePage from "@/components/common/ResourcePage";
import { PageHeader } from "@/components/common/States";
import { useWorkspace } from "@/context/WorkspaceContext";
import { tasks } from "@/lib/resources";
import { errorMessage } from "@/lib/api";

export default function Tasks() {
  const { api, can } = useWorkspace();
  const markDone = (row, reload) => async () => {
    try { await api.patch(`/tasks/${row.id}`, { status: "done" }); toast.success("Task completed"); reload(); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  return (
    <div data-testid="tasks-page">
      <PageHeader eyebrow="Workflow" title="Tasks & Follow-ups" description="Follow-ups, calls and research tasks linked to accounts and opportunities." />
      <ResourcePage config={tasks} fixedParams={{}}
        extraRowActions={(row, reload) => (can("write") && row.status !== "done" ? [{ id: "done", label: "Mark as done", onClick: markDone(row, reload) }] : [])} />
    </div>
  );
}
